<div class="topdiv">
  <!-- Make this container scrollable -->
   
  
    

    
     


    <div class="testbed" >
    
    
    <div class="row" style="margin-top: -2%;">
    <div class="col-lg-1"></div>
    <div *ngIf="selectedGrid === 'new'" class="col-lg-12">
      
        


        
        <mat-toolbar class="agGridtoperDiv card"
          style="background: rgb(244 243 245); border-top: 1px solid #a9a9a9a8; border-right: 1px solid #a9a9a9a8; border-left: 1px solid #a9a9a9a8;">
          <label i18n="@@spmsUserReg" class="textColour">{{CornerHeaderName}}</label>
          <span class="example-spacer"></span>

          <!-- <mat-checkbox *ngIf="CornerHeaderName === 'Verify Mapping'" [(ngModel)]="reverifyStage" style="margin-right: 15px; font-size: medium;">Reverify Stage</mat-checkbox> -->

          <button
          class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
          [style.background-color]="backgroundColorButton"
          title="Download"
          (click)="onBtExport()"
          style="font-size: 12px; padding: 4px 10px; height: 32px"
        >
          Download
          <em
            class="fas fa-download example-icon"
            style="font-size: 12px; padding: 0 5px"
          ></em>
        </button>

          <div class="insertPageNoDiv">
            <mat-form-field appearance="outline">
              <mat-label i18n="@@Targetpageno">Page No</mat-label>
              <input matInput type="text" (input)="onRunSearchChange($event.target.value)">
            </mat-form-field>
          </div>

          <div class="selectRecordsDiv" style="width:9.5%">
            <mat-form-field appearance="outline" style="width:100%">
              <mat-label i18n="@@Targetrecords" style="color:black">Records</mat-label>
              <mat-select  [(ngModel)]="RunpageSize1"  (ngModelChange)="onRunPageSizeChanged(value)">
                <mat-option value="10" selected>10</mat-option>
                <mat-option value="200">200</mat-option>
                <mat-option value="300">300</mat-option>
                <mat-option value="400">400</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="card pagination paginationFirstButton paginationFirstlastButton">
            <em class="fas fa-angle-double-left waves-effect waves-light" (click)="onRunBtFirst1()"></em>
          </div>

          <div class="card pagination paginationButtons btn-rounded">
            <ul>
              <li class="paginationliicon">
                <em class="fas fa-angle-left waves-effect waves-light" (click)="onRunBtPrevious1()"></em>
              </li>
              <li>{{RuncurrentPage1}}/{{RuntotalPages1}}</li>
              <li class="paginationliicon" style="padding:0;">
                <em class="fas fa-angle-right waves-effect waves-light" (click)="onRunBtNext1()"></em>
              </li>
            </ul>
          </div>

          <div class="card pagination paginationLastButton paginationFirstlastButton">
            <em class="fas fa-angle-double-right waves-effect waves-light" (click)="onRunBtLast1()"></em>
          </div>
        </mat-toolbar>
        
      

      <ag-grid-angular 
        class="ag-theme-balham table-width tablestyles square scroolbar-dusty-grass square thin"
        [columnDefs]="columnDefsExtractTemp"
        [animateRows]="true"
        [pagination]="true"
        [suppressPaginationPanel]="true"
        [rowHeight]="35"
        [headerHeight]="35"
        [enableBrowserTooltips]="true"
        [defaultColDef]="defaultColDef"
        [floatingFiltersHeight]="45"
        [paginationPageSize]="paginationPageSize"
        [paginationNumberFormatter]="paginationNumberFormatter"
        [enableRangeSelection]="true"
        [debug]="true"
        (paginationChanged)="onloadPaginationChanged1()"
        [components]="components"
        (gridReady)="cellClickedObjects($event)"
        [hidden]="!true"
        style="height: 55vh;">
      </ag-grid-angular>
    </div>
    </div>
    
    </div>
  

  <div style="height: 5vh; padding: 20px;margin-bottom: 5%;">

      <div class="row" style="position: sticky; left: 0; bottom: 0; width: 100%; background-color: white;">
        <div class="col-lg text-center">
          <div style="text-align: end;">
            <button type="button" (click)="create()"
              class="btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
              [style.background-color]="backgroundColorButton"
              style="padding: .3rem 1.6rem; font-size: .85rem; width: 150px; color: white;">{{CornerHeaderName}}</button>

            <button type="button" (click)="cancel()"
              class="btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
              [style.background-color]="backgroundColorButton"
              style="padding: .3rem 1.6rem; font-size: .85rem; width: 150px; color: white;">Cancel</button>
          </div>
        </div>
      </div>
    </div>
</div>
